import React from "react";
import NotificationBlock from "./notificationBlock";
import useNotifications from "../../../customhooks/useNotifications/useNotifications";
import useExistFocus from "../../../customhooks/useExitFocus/useExistFocus";

function NotificationMenu() {
  // states
  const [showNotificationBlock, setShowNotificationBlock] =
    React.useState(false);
  const [notificationFilter, setNotificationFilter] = React.useState("all"); // isRead: boolean | undefined
  const [shouldRefetch, setShouldRefetch] = React.useState(false); // isRead: boolean | undefined

  // hooks
  const { notifications } = useNotifications(
    { isRead: notificationFilter },
    shouldRefetch
  );
  const notificationRef = useExistFocus(() => {
    setShowNotificationBlock(false);
  });

  //   functions
  const refetch = () => setShouldRefetch(!shouldRefetch);

  return (
    <>
      <img
        src="/img/vectors/notification.svg"
        alt="notification"
        className="h-[1.1rem] w-[1.1rem] cursor-pointer"
        onClick={() => setShowNotificationBlock(!showNotificationBlock)}
      />

      {showNotificationBlock ? (
        <div
          className="notification-block absolute shadow-lg rounded-md left-[-150px] top-[30px] w-[20rem]  bg-appcolorwhite"
          ref={notificationRef}
          style={{ zIndex: 1000, maxHeight: "calc(100vh - 150px)" }}
        >
          <NotificationBlock
            notifications={notifications}
            setNotificationFilter={setNotificationFilter}
            refetch={refetch}
            setClose={() => setShowNotificationBlock(false)}
          />
        </div>
      ) : null}
    </>
  );
}

export default NotificationMenu;
